import { useState } from 'react';

export type UseMarqueeAnimationParams = {
  speed?: number;
  duration?: number;
};

export function useMarqueeAnimation(config: UseMarqueeAnimationParams = {}) {
  const { duration = 40 } = config;
  const [isPaused, setIsPaused] = useState(false);

  const pauseMarquee = () => {
    setIsPaused(true);
  };

  const playMarquee = () => {
    setIsPaused(false);
  };

  return {
    duration,
    isPaused,
    playMarquee,
    pauseMarquee,
  };
}
